import _toConsumableArray from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
// src/should-forward-prop.ts
import { propNames } from "@chakra-ui/styled-system";
var allPropNames = /* @__PURE__ */new Set([].concat(_toConsumableArray(propNames), ["textStyle", "layerStyle", "apply", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"]));
var validHTMLProps = /* @__PURE__ */new Set(["htmlWidth", "htmlHeight", "htmlSize"]);
function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
}
export { shouldForwardProp };